export const PLATFORM_SKILLS = [
  'Platform Engineering',
  'AWS',
  'Terraform',
  'ECS Fargate',
  'Kubernetes',
  'Docker',
  'Linux',
]

export const DELIVERY_SKILLS = [
  'GitHub Actions',
  'Jenkins',
  'GitLab CI',
  'DevSecOps',
  'Observability',
  'Datadog',
  'Snyk',
]

export const SOFTWARE_SKILLS = [
  'Python',
  'TypeScript',
  'FastAPI',
  'React',
  'Dagster',
  'Node.js',
  'PostgreSQL',
]

export const ALL_MAIN_SKILLS = [
  ...PLATFORM_SKILLS,
  ...DELIVERY_SKILLS,
  ...SOFTWARE_SKILLS,
]
